import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import Spinner from '../spinner/spinner';
import NotFound from '../pages/notFound/notFound';
import { getCurrentUser } from './queries/getCurrentUser';

const Authorization = (allowedRoles, props = {}) => {
  return (WrappedComponent) => {
    class WithAuthorization extends Component {
      static propTypes = {
        data: PropTypes.shape({
          loading: PropTypes.bool.isRequired,
          error: PropTypes.object,
          current_user: PropTypes.object
        }).isRequired
      };

      isAccessPermitted(role) {
        role = role || '';
        return allowedRoles.map((role) => role.toLowerCase()).includes(role.toLowerCase());
      }

      render() {
        const { loading, error, current_user: user } = this.props.data;
        if (loading) {
          return <Spinner />
        } else if (error) {
          console.log(error);
          return <Redirect to="/auth/login" />
        } else {
          if (!user) {
            return <Redirect to="/auth/login" />
          }
          else if (this.isAccessPermitted(user.type)) {
            return <WrappedComponent {...props} {...this.props} />
          } else {
            return <NotFound />
          }
        }
      }
    }

    return graphql(getCurrentUser)(WithAuthorization);
  }
};

export default Authorization;



// WEBPACK FOOTER //
// ./src/components/authorization/authorization.js